"use client"

import { Dialog, DialogPanel, Description, DialogTitle } from "@headlessui/react"

interface AnalysisModalProps {
  isOpen: boolean
  onClose: () => void
}

export function AnalysisModal({ isOpen, onClose }: AnalysisModalProps) {
  const metrics = [
    { label: "Active communication", value: 8.5, color: "rgb(34, 197, 94)" },
    { label: "Conflict resolution", value: 8.0, color: "rgb(34, 197, 94)" },
    { label: "Empathy", value: 6.5, color: "rgb(59, 130, 246)" },
    { label: "Goal setting", value: 4.5, color: "rgb(249, 115, 22)" },
  ]

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="w-full max-w-2xl rounded-lg bg-white p-6 shadow-xl">
          <div className="space-y-4">
            <DialogTitle className="text-2xl font-semibold">
              Roleplay analysis is not available for this session
            </DialogTitle>

            <Description className="text-gray-600">
              Your conversation was too brief to analyze. Complete a longer session to unlock a detailed report on your
              strengths, areas for improvements, skills assessment, and more!
            </Description>

            <img
              src="https://dopmo1eihgbgm.cloudfront.net/678d60ea1e8bf3729333dcb8/roleplay-summary-sample.png"
              alt="Analysis Report Preview"
              className="w-full rounded-lg shadow-md"
            />

            <div className="mt-6 pt-6 flex justify-end">
              <button
                onClick={onClose}
                className="rounded-full border bg-white border-gray-300 bg-white px-8 py-3 text-base font-medium text-gray-900 transition-colors hover:bg-gray-50"
              >
                Close
              </button>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}

